import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Titlebar from './components/Titlebar/Titlebar';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Committee from './components/Committee/Committee';
import Ieee_banner from './components/Slider/Ieee_banner';
import Progressbar from './components/Slider/Progressbar';
import Home from './components/Home/Home';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Slider from './components/Slider/Slider';
import Tracks from './components/Tracks/Tracks';
import Guideline from './components/Guideline/Guideline';
import Submission from './components/Submission/Submission';
import Special from './components/Special_sessions/Special';
import Speakers from './components/Speakers/Speakers';
import Previous_conference from './components/Previous_conferences/Previous_conference';
import Registration from './components/Registration/Registration';
import Schedule from './components/Schedule/Schedule';
import Home1 from './components/Home/Home1';
import Testimony from './components/Testimonials/Testimony';
import Special_sessions from './components/Special_sessions/Special_sessions';
import Sponsors from './components/Sponsors/Sponsors';
import Notification from './components/Notification/Notification';
import Contact_location from './components/Contact/Contact_location';

function App() {
  return (
    <BrowserRouter>
      <Titlebar />
      <Navbar />
      <Slider />
      <Notification/>
      <Routes>
        <Route path="/" element={<><Home1/><Ieee_banner/><Sponsors/><Testimony/></>} />
        {/* <Route path="/" element={<><Home1/><Ieee_banner/><Testimony/></>} /> */}
        <Route path="/Committee" element={<Committee/>} />
        <Route path="/tracks" element={<Tracks/>} />
        <Route path='/guidelines' element={ <Guideline/>} />
        <Route path='/submission' element={ <Submission/> } />
        <Route path='/special_sessions' element={<Special/>} />
        <Route path='/Special' element={<Special_sessions/>} />
        <Route path='/speakers' element={ <Speakers/> } />
        <Route path='/previous_conferences' element={<Previous_conference/>} />
        <Route path='/registration' element={<Registration/>} />
        <Route path='/schedule' element={<Schedule/>} />
        <Route path='/contact_loc' element={<Contact_location/>} />
      </Routes>
      {/* <Contact /> */}
      <Footer />
    </BrowserRouter>
  );
}

export default App;
